import Vue from 'vue'
import PrimeVue from 'primevue/config'
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ColumnGroup from 'primevue/columngroup'
import Row from 'primevue/row'
import Dropdown from 'primevue/dropdown'
import 'primeicons/primeicons.css'

Vue.use(PrimeVue, { ripple: true })
// Theme & core styles (for PrimeVue v2)
// import 'primeicons/primeicons.css'

// Optionally register components globally
Vue.component('Button', Button)
Vue.component('DataTable', DataTable)
Vue.component('Column', Column)
Vue.component('ColumnGroup', ColumnGroup)
Vue.component('Row', Row)
Vue.component('Dropdown', Dropdown)
